export enum LocalProductSidePanelTabValues {
    General = 'general',
    Pricing = 'pricing',
    Services = 'services',
    Accounting = 'accounting',
}
